import { Directive } from '@angular/core';

@Directive({
  selector: '[profileImage]',
  host: { class: 'profile-image' }
})
export class ProfileCardImageDirective {}

export { ProfileCardHoverDirective } from './profile-card-hover.directive';
